module.exports = __webpack_public_path__ + "img/car_3 - 副本.88e4a54c.png";